<template>
	<v-list style="background: transparent" flat>
		<v-list-item-group v-model="selectedItem">
			<SwipeList
				ref="swipelist"
				:items="items"
				item-key="id"
				@active="onSwipeOutActive"
				@swipeout:click="onSwipeOutClick"
			>
				<template v-slot="{ item }">
					<v-list-item>
						<v-list-item-title v-text="item[itemText]" />
					</v-list-item>
				</template>

				<template #right="{ item }">
					<device-misc-swipe-action
						v-for="option in options"
						:key="option.title"
						:type="option.type"
						:item="item"
						@click="option.action"
					/>
				</template>
			</SwipeList>
		</v-list-item-group>
	</v-list>
</template>

<script>
import { SwipeList } from "vue-swipe-actions";

export default {
	components: {
		SwipeList,
	},

	props: {
		items: {
			type: Array,
			required: true,
		},
		itemText: String,
		options: Array,
	},

	data() {
		return {
			selectedItem: null,
		};
	},

	methods: {
		onSwipeOutActive(event) {
			this.$refs.swipelist.closeActions();
		},

		onSwipeOutClick(item) {
			this.$refs.swipelist.closeActions();
			this.$emit("change", item);
			this.$emit("click", item);
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
